import { render } from "./XRayAverageRange.vue?vue&type=template&id=27736b21&scoped=true"
import script from "./XRayAverageRange.vue?vue&type=script&lang=js"
export * from "./XRayAverageRange.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-27736b21"

export default script